import {
  Amazon,
  Depop,
  Ebay,
  Etsy,
  Facebook,
  Google,
  Instagram,
  Mercari,
  Mercadolibre,
  Lazada,
  LinkedIn,
  Poshmark,
  Shopee,
  Shopify,
  TikTok,
  Twitter,
  Vinted,
  WhatsApp,
  Website,
  YouTube,
} from 'blaze-ui/icons'
import { Brainstorm } from 'blaze-ui/icons/24/Brainstorm'
import { DesignChannel } from 'components/NewFileModal/Types'
import { MultiStepSchema, WizardType } from './Types'
import { FlowA1Schema } from '../MobileWizards/MobileWizard/Flows/FlowA1/schema'
import { FlowA2Schema } from '../MobileWizards/MobileWizard/Flows/FlowA2/schema'
import { FlowBSchema } from '../MobileWizards/MobileWizard/Flows/FlowB/schema'
import { FlowCSchema } from '../MobileWizards/MobileWizard/Flows/FlowC/schema'
import { FlowDSchema } from '../MobileWizards/MobileWizard/Flows/FlowD/schema'
import { FlowESchema } from '../MobileWizards/MobileWizard/Flows/FlowE/schema'
import { FlowFSchema } from '../MobileWizards/MobileWizard/Flows/FlowF/schema'
import { FlowGSchema } from '../MobileWizards/MobileWizard/Flows/FlowG/schema'
import { FlowISchema } from '../MobileWizards/MobileWizard/Flows/FlowI/schema'
import { FlowZ1Schema } from '../MobileWizards/MobileWizard/Flows/FlowZ1/schema'
import { FlowZ2Schema } from '../MobileWizards/MobileWizard/Flows/FlowZ2/schema'
import { FlowK1Schema } from '../MobileWizards/MobileWizard/Flows/FlowK1/schema'
import { FlowJSchema } from '../MobileWizards/MobileWizard/Flows/FlowJ/schema'
import { FlowLSchema } from '../MobileWizards/MobileWizard/Flows/FlowL/schema'
import { FlowM1Schema } from '../MobileWizards/MobileWizard/Flows/FlowM1/schema'
import { FlowM2Schema } from '../MobileWizards/MobileWizard/Flows/FlowM2/schema'
import { FlowM3Schema } from '../MobileWizards/MobileWizard/Flows/FlowM3/schema'
import { FlowNSchema } from '../MobileWizards/MobileWizard/Flows/FlowN/schema'
import { FlowOSchema } from '../MobileWizards/MobileWizard/Flows/FlowO/schema'
import { FlowP1Schema } from '../MobileWizards/MobileWizard/Flows/FlowP1/schema'
import { FlowP2Schema } from '../MobileWizards/MobileWizard/Flows/FlowP2/schema'
import { FlowP3Schema } from '../MobileWizards/MobileWizard/Flows/FlowP3/schema'
import { FlowRSchema } from '../MobileWizards/MobileWizard/Flows/FlowR/schema'
import { FlowH1Schema } from '../MobileWizards/MobileWizard/Flows/FlowH1/schema'

import { ChannelType } from 'components/CampaignCreationModal/Types'
import { PressRelease } from 'almanac-ui/icons/blaze/32'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { Blog } from 'almanac-ui/icons/blaze/24/Blog'

type WizardSchemas<T extends WizardType = WizardType> = Partial<{ [key in T]: MultiStepSchema<T> }>

type DesignChannelSchemas = WizardSchemas<DesignChannel>
type ChannelTypeSchemas = WizardSchemas<ChannelType>
type GenerationTypeSchemas = WizardSchemas<GenerationType>

export const flowA1Schemas: DesignChannelSchemas = {
  [DesignChannel.InstagramPost]: {
    ...FlowA1Schema({ generationType: DesignChannel.InstagramPost }),
    meta: {
      type: DesignChannel.InstagramPost,
      channel: DesignChannel.InstagramPost,
      title: 'Instagram Post',
      icon: Instagram,
      previewUrl: '',
      aspectRatios: {
        portrait: 'instagram-portrait-post',
        landscape: 'instagram-landscape-post',
        square: 'instagram-square-post',
      },
    },
  },
  [DesignChannel.FacebookPost]: {
    ...FlowA1Schema({ generationType: DesignChannel.FacebookPost }),
    meta: {
      type: DesignChannel.FacebookPost,
      channel: DesignChannel.FacebookPost,
      title: 'Facebook Post',
      icon: Facebook,
      previewUrl: '',
    },
  },
  [DesignChannel.LinkedInPost]: {
    ...FlowA1Schema({ generationType: DesignChannel.LinkedInPost }),
    meta: {
      type: DesignChannel.LinkedInPost,
      channel: DesignChannel.LinkedInPost,
      title: 'LinkedIn Post',
      icon: LinkedIn,
      previewUrl: '',
      aspectRatios: {
        landscape: 'linkedin-post',
      },
      altWizard: ChannelType.LinkedInPosts,
    },
  },
  [DesignChannel.TwitterPost]: {
    ...FlowA1Schema({ generationType: DesignChannel.TwitterPost }),
    meta: {
      type: DesignChannel.TwitterPost,
      channel: DesignChannel.TwitterPost,
      title: 'X/Twitter Post',
      icon: Twitter,
      previewUrl: '',
      aspectRatios: {
        landscape: 'twitter-post',
      },
      altWizard: ChannelType.Tweets,
    },
  },
}

export const flowA2Schemas: DesignChannelSchemas = {
  [DesignChannel.InstagramStory]: {
    ...FlowA2Schema({ generationType: DesignChannel.InstagramStory }),
    meta: {
      type: DesignChannel.InstagramStory,
      channel: DesignChannel.InstagramStory,
      title: 'Instagram Story',
      icon: Instagram,
      previewUrl: '',
      aspectRatios: {
        portrait: 'instagram-story',
      },
    },
  },
}

export const flowBSchemas: DesignChannelSchemas = {
  [DesignChannel.LinkedInProfilePicture]: {
    ...FlowBSchema({ generationType: DesignChannel.LinkedInProfilePicture }),
    meta: {
      type: DesignChannel.LinkedInProfilePicture,
      channel: DesignChannel.LinkedInProfilePicture,
      title: 'LinkedIn Profile Picture',
      icon: LinkedIn,
      previewUrl: '',
      aspectRatios: {
        square: 'linkedin-profile-picture',
      },
      templateBorderRadius: '50%',
    },
  },
  [DesignChannel.LinkedInBanner]: {
    ...FlowBSchema({ generationType: DesignChannel.LinkedInBanner }),
    meta: {
      type: DesignChannel.LinkedInBanner,
      channel: DesignChannel.LinkedInBanner,
      title: 'LinkedIn Banner',
      icon: LinkedIn,
      previewUrl: '',
      aspectRatios: {
        landscape: 'linkedin-banner',
      },
    },
  },
  [DesignChannel.FacebookProfilePicture]: {
    ...FlowBSchema({ generationType: DesignChannel.FacebookProfilePicture }),
    meta: {
      type: DesignChannel.FacebookProfilePicture,
      channel: DesignChannel.FacebookProfilePicture,
      title: 'Facebook Profile Picture',
      icon: Facebook,
      previewUrl: '',
      aspectRatios: {
        square: 'facebook-profile-picture',
      },
      templateBorderRadius: '50%',
    },
  },
  [DesignChannel.FacebookCover]: {
    ...FlowBSchema({ generationType: DesignChannel.FacebookCover }),
    meta: {
      type: DesignChannel.FacebookCover,
      channel: DesignChannel.FacebookCover,
      title: 'Facebook Cover Image',
      icon: Facebook,
      previewUrl: '',
      aspectRatios: {
        landscape: 'facebook-cover',
      },
    },
  },
  [DesignChannel.TwitterProfilePicture]: {
    ...FlowBSchema({ generationType: DesignChannel.TwitterProfilePicture }),
    meta: {
      type: DesignChannel.TwitterProfilePicture,
      channel: DesignChannel.TwitterProfilePicture,
      title: 'X/Twitter Profile Picture',
      icon: Twitter,
      previewUrl: '',
      aspectRatios: {
        square: 'twitter-profile-picture',
      },
      templateBorderRadius: '50%',
    },
  },
  [DesignChannel.TwitterCoverImage]: {
    ...FlowBSchema({ generationType: DesignChannel.TwitterCoverImage }),
    meta: {
      type: DesignChannel.TwitterCoverImage,
      channel: DesignChannel.TwitterCoverImage,
      title: 'X/Twitter Cover Image',
      icon: Twitter,
      previewUrl: '',
      aspectRatios: {
        landscape: 'twitter-cover-image',
      },
    },
  },
  [DesignChannel.WhatsAppSticker]: {
    ...FlowBSchema({ generationType: DesignChannel.WhatsAppSticker }),
    meta: {
      type: DesignChannel.WhatsAppSticker,
      channel: DesignChannel.WhatsAppSticker,
      title: 'WhatsApp Sticker',
      icon: WhatsApp,
      previewUrl: '',
      aspectRatios: {
        square: 'whatsapp-sticker',
      },
    },
  },
  [DesignChannel.TikTokThumbnail]: {
    ...FlowBSchema({ generationType: DesignChannel.TikTokThumbnail }),
    meta: {
      type: DesignChannel.TikTokThumbnail,
      channel: DesignChannel.TikTokThumbnail,
      title: 'TikTok Thumbnail',
      icon: TikTok,
      previewUrl: '',
      aspectRatios: {
        square: 'tik-tok-thumbnail',
      },
    },
  },
  [DesignChannel.YoutubeProfilePicture]: {
    ...FlowBSchema({ generationType: DesignChannel.YoutubeProfilePicture }),
    meta: {
      type: DesignChannel.YoutubeProfilePicture,
      channel: DesignChannel.YoutubeProfilePicture,
      title: 'YouTube Profile Picture',
      icon: YouTube,
      previewUrl: '',
      aspectRatios: {
        square: 'youtube-profile-picture',
      },
      templateBorderRadius: '50%',
    },
  },
  [DesignChannel.YoutubeChannelArt]: {
    ...FlowBSchema({ generationType: DesignChannel.YoutubeChannelArt }),
    meta: {
      type: DesignChannel.YoutubeChannelArt,
      channel: DesignChannel.YoutubeChannelArt,
      title: 'YouTube Channel Art',
      icon: YouTube,
      previewUrl: '',
      aspectRatios: {
        landscape: 'youtube-channel-art',
      },
    },
  },
}

export const flowCSchemas: ChannelTypeSchemas = {
  [ChannelType.LinkedInPosts]: {
    ...FlowCSchema({ generationType: ChannelType.LinkedInPosts }),
    meta: {
      type: ChannelType.LinkedInPosts,
      channel: ChannelType.LinkedInPosts,
      title: 'LinkedIn Text Post',
      icon: LinkedIn,
      previewUrl: '',
      aspectRatios: {
        landscape: 'linkedin-post',
      },
    },
  },
  [ChannelType.Tweets]: {
    ...FlowCSchema({ generationType: ChannelType.Tweets }),
    meta: {
      type: ChannelType.Tweets,
      channel: ChannelType.Tweets,
      title: 'X/Twitter Post',
      icon: Twitter,
      previewUrl: '',
      aspectRatios: {
        landscape: 'twitter-post',
      },
    },
  },
}

export const flowDSchemas: ChannelTypeSchemas = {
  [ChannelType.TweetThread]: {
    ...FlowDSchema({ generationType: ChannelType.TweetThread }),
    meta: {
      type: ChannelType.TweetThread,
      channel: ChannelType.TweetThread,
      title: 'Twitter Thread',
      icon: Twitter,
      previewUrl: '',
    },
  },
}

export const flowESchemas: ChannelTypeSchemas = {
  [ChannelType.ProductLaunchWebsite]: {
    ...FlowESchema({ generationType: ChannelType.ProductLaunchWebsite }),
    meta: {
      type: ChannelType.ProductLaunchWebsite,
      channel: ChannelType.ProductLaunchWebsite,
      title: 'Website Copy',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.ProductLaunchGoogle]: {
    ...FlowESchema({ generationType: ChannelType.ProductLaunchGoogle }),
    meta: {
      type: ChannelType.ProductLaunchGoogle,
      channel: ChannelType.ProductLaunchGoogle,
      title: 'Google Shop Copy',
      icon: Google,
      previewUrl: '',
    },
  },
  [ChannelType.ProductLaunchEtsy]: {
    ...FlowESchema({ generationType: ChannelType.ProductLaunchEtsy }),
    meta: {
      type: ChannelType.ProductLaunchEtsy,
      channel: ChannelType.ProductLaunchEtsy,
      title: 'Etsy Product Copy',
      icon: Etsy,
      previewUrl: '',
    },
  },
  [ChannelType.ProductLaunchAmazon]: {
    ...FlowESchema({ generationType: ChannelType.ProductLaunchAmazon }),
    meta: {
      type: ChannelType.ProductLaunchAmazon,
      channel: ChannelType.ProductLaunchAmazon,
      title: 'Amazon Product Copy',
      icon: Amazon,
      previewUrl: '',
    },
  },
  [ChannelType.ProductLaunchShopify]: {
    ...FlowESchema({ generationType: ChannelType.ProductLaunchShopify }),
    meta: {
      type: ChannelType.ProductLaunchShopify,
      channel: ChannelType.ProductLaunchShopify,
      title: 'Shopify Product Copy',
      icon: Shopify,
      previewUrl: '',
    },
  },
}

export const flowFSchemas: DesignChannelSchemas = {
  [DesignChannel.Vinted]: {
    ...FlowFSchema({ generationType: DesignChannel.Vinted }),
    meta: {
      type: DesignChannel.Vinted,
      channel: DesignChannel.Vinted,
      title: 'Vinted Visual',
      icon: Vinted,
      previewUrl: '',
    },
  },
  [DesignChannel.Ebay]: {
    ...FlowFSchema({ generationType: DesignChannel.Ebay }),
    meta: {
      type: DesignChannel.Ebay,
      channel: DesignChannel.Ebay,
      title: 'Ebay Visual',
      icon: Ebay,
      previewUrl: '',
    },
  },
  [DesignChannel.Poshmark]: {
    ...FlowFSchema({ generationType: DesignChannel.Poshmark }),
    meta: {
      type: DesignChannel.Poshmark,
      channel: DesignChannel.Poshmark,
      title: 'Poshmark Visual',
      icon: Poshmark,
      previewUrl: '',
    },
  },
  [DesignChannel.Depop]: {
    ...FlowFSchema({ generationType: DesignChannel.Depop }),
    meta: {
      type: DesignChannel.Depop,
      channel: DesignChannel.Depop,
      title: 'Depop Visual',
      icon: Depop,
      previewUrl: '',
    },
  },
  [DesignChannel.Mercari]: {
    ...FlowFSchema({ generationType: DesignChannel.Mercari }),
    meta: {
      type: DesignChannel.Mercari,
      channel: DesignChannel.Mercari,
      title: 'Mercari Visual',
      icon: Mercari,
      previewUrl: '',
    },
  },
  [DesignChannel.MercadoLibre]: {
    ...FlowFSchema({ generationType: DesignChannel.MercadoLibre }),
    meta: {
      type: DesignChannel.MercadoLibre,
      channel: DesignChannel.MercadoLibre,
      title: 'MercadoLibre Visual',
      icon: Mercadolibre,
      previewUrl: '',
    },
  },
  [DesignChannel.Shopee]: {
    ...FlowFSchema({ generationType: DesignChannel.Shopee }),
    meta: {
      type: DesignChannel.Shopee,
      channel: DesignChannel.Shopee,
      title: 'Shopee Visual',
      icon: Shopee,
      previewUrl: '',
    },
  },
  [DesignChannel.Lazada]: {
    ...FlowFSchema({ generationType: DesignChannel.Lazada }),
    meta: {
      type: DesignChannel.Lazada,
      channel: DesignChannel.Lazada,
      title: 'Lazada Visual',
      icon: Lazada,
      previewUrl: '',
    },
  },
  [DesignChannel.Etsy]: {
    ...FlowFSchema({ generationType: DesignChannel.Etsy }),
    meta: {
      type: DesignChannel.Etsy,
      channel: DesignChannel.Etsy,
      title: 'Etsy Visual',
      icon: Etsy,
      previewUrl: '',
    },
  },
  [DesignChannel.Amazon]: {
    ...FlowFSchema({ generationType: DesignChannel.Amazon }),
    meta: {
      type: DesignChannel.Amazon,
      channel: DesignChannel.Amazon,
      title: 'Amazon Visual',
      icon: Amazon,
      previewUrl: '',
    },
  },
}

export const flowGSchemas: DesignChannelSchemas = {
  [DesignChannel.InstagramReel]: {
    ...FlowGSchema({ generationType: DesignChannel.InstagramReel }),
    meta: {
      type: DesignChannel.InstagramReel,
      channel: DesignChannel.InstagramReel,
      title: 'Instagram Reel',
      icon: Instagram,
      previewUrl: '',
      aspectRatios: {
        portrait: 'instagram-reel',
      },
    },
  },
  [DesignChannel.TikTokPost]: {
    ...FlowGSchema({ generationType: DesignChannel.TikTokPost }),
    meta: {
      type: DesignChannel.TikTokPost,
      channel: DesignChannel.TikTokPost,
      title: 'TikTok Post',
      icon: TikTok,
      previewUrl: '',
      aspectRatios: {
        portrait: 'tik-tok-post',
      },
    },
  },
}

export const flowISchemas: GenerationTypeSchemas = {
  [GenerationType.InstagramPlanning]: {
    ...FlowISchema({ generationType: GenerationType.InstagramPlanning }),
    meta: {
      type: GenerationType.InstagramPlanning,
      channel: GenerationType.InstagramPlanning,
      title: 'Multiple Instagram Posts',
      icon: Instagram,
      previewUrl: '',
    },
  },
  [GenerationType.FacebookPlanning]: {
    ...FlowISchema({ generationType: GenerationType.FacebookPlanning }),
    meta: {
      type: GenerationType.FacebookPlanning,
      channel: GenerationType.FacebookPlanning,
      title: 'Multiple Facebook Posts',
      icon: Facebook,
      previewUrl: '',
    },
  },
  [GenerationType.TwitterPlanning]: {
    ...FlowISchema({ generationType: GenerationType.TwitterPlanning }),
    meta: {
      type: GenerationType.TwitterPlanning,
      channel: GenerationType.TwitterPlanning,
      title: 'Multiple X/Twitter Posts',
      icon: Twitter,
      previewUrl: '',
    },
  },
  [GenerationType.LinkedInPlanning]: {
    ...FlowISchema({ generationType: GenerationType.LinkedInPlanning }),
    meta: {
      type: GenerationType.LinkedInPlanning,
      channel: GenerationType.LinkedInPlanning,
      title: 'Multiple LinkedIn Posts',
      icon: LinkedIn,
      previewUrl: '',
    },
  },
}

export const flowJSchemas: GenerationTypeSchemas = {
  [GenerationType.Brainstorm]: {
    ...FlowJSchema({ generationType: GenerationType.Brainstorm }),
    meta: {
      type: GenerationType.Brainstorm,
      channel: GenerationType.Brainstorm,
      title: 'Brainstorm Content',
      icon: Brainstorm,
      previewUrl: '',
    },
  },
}

export const flowK1Schemas: ChannelTypeSchemas = {
  [ChannelType.BlogPost]: {
    ...FlowK1Schema({ generationType: ChannelType.BlogPost }),
    meta: {
      type: ChannelType.BlogPost,
      channel: ChannelType.BlogPost,
      title: 'Blog Post',
      icon: Blog,
      previewUrl:
        'https://res.cloudinary.com/almanac/image/upload/v1710183787/Home%20Card%20Previews/xfpedur3adlb5odloqfm.png',
    },
  },
}

export const flowLSchemas: ChannelTypeSchemas = {
  [ChannelType.CaseStudy]: {
    ...FlowLSchema({ generationType: ChannelType.CaseStudy }),
    meta: {
      type: ChannelType.CaseStudy,
      channel: ChannelType.CaseStudy,
      title: 'Case Study',
      icon: Website,
      previewUrl: '',
    },
  },
}

export const flowM1Schemas: ChannelTypeSchemas = {
  [ChannelType.PressRelease]: {
    ...FlowM1Schema({ generationType: ChannelType.PressRelease }),
    meta: {
      type: ChannelType.PressRelease,
      channel: ChannelType.PressRelease,
      title: 'Press Release',
      icon: PressRelease,
      previewUrl: '',
      submitLabel: 'Generate Press Release',
    },
  },
}

export const flowM2Schemas: GenerationTypeSchemas = {
  [GenerationType.Outline]: {
    ...FlowM2Schema({ generationType: GenerationType.Outline }),
    meta: {
      type: GenerationType.Outline,
      channel: GenerationType.Outline,
      title: 'Content Outline',
      previewUrl: '',
      submitLabel: 'Generate Content Outline',
    },
  },
}

export const flowM3Schemas: GenerationTypeSchemas = {
  [GenerationType.ContentBrief]: {
    ...FlowM3Schema({ generationType: GenerationType.Outline }),
    meta: {
      type: GenerationType.ContentBrief,
      channel: GenerationType.ContentBrief,
      title: 'Content Brief',
      previewUrl: '',
      submitLabel: 'Generate Content Brief',
    },
  },
}

export const flowNSchemas: ChannelTypeSchemas = {
  [ChannelType.PromotionalEmailSequence]: {
    ...FlowNSchema({ generationType: ChannelType.PromotionalEmailSequence }),
    meta: {
      type: ChannelType.PromotionalEmailSequence,
      channel: ChannelType.PromotionalEmailSequence,
      title: 'Promotional Email Sequence',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.NurtureEmailSequence]: {
    ...FlowNSchema({ generationType: ChannelType.NurtureEmailSequence }),
    meta: {
      type: ChannelType.NurtureEmailSequence,
      channel: ChannelType.NurtureEmailSequence,
      title: 'Nurture Sequence',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.WelcomeSeries]: {
    ...FlowNSchema({ generationType: ChannelType.WelcomeSeries }),
    meta: {
      type: ChannelType.WelcomeSeries,
      channel: ChannelType.WelcomeSeries,
      title: 'Welcome Series',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.DidntSignUp]: {
    ...FlowNSchema({ generationType: ChannelType.DidntSignUp }),
    meta: {
      type: ChannelType.DidntSignUp,
      channel: ChannelType.DidntSignUp,
      title: "Didn't Sign Up",
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.AbandonedCart]: {
    ...FlowNSchema({ generationType: ChannelType.AbandonedCart }),
    meta: {
      type: ChannelType.AbandonedCart,
      channel: ChannelType.AbandonedCart,
      title: 'Abandoned Cart',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.LostCustomer]: {
    ...FlowNSchema({ generationType: ChannelType.LostCustomer }),
    meta: {
      type: ChannelType.LostCustomer,
      channel: ChannelType.LostCustomer,
      title: 'Lost Customer',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.WarmOutboundEmailSequence]: {
    ...FlowNSchema({ generationType: ChannelType.WarmOutboundEmailSequence }),
    meta: {
      type: ChannelType.WarmOutboundEmailSequence,
      channel: ChannelType.WarmOutboundEmailSequence,
      title: 'Warm Outbound Emails',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.ColdOutboundEmailSequence]: {
    ...FlowNSchema({ generationType: ChannelType.ColdOutboundEmailSequence }),
    meta: {
      type: ChannelType.ColdOutboundEmailSequence,
      channel: ChannelType.ColdOutboundEmailSequence,
      title: 'Cold Outbound Emails',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.CandidateNurtureSequence]: {
    ...FlowNSchema({ generationType: ChannelType.CandidateNurtureSequence }),
    meta: {
      type: ChannelType.CandidateNurtureSequence,
      channel: ChannelType.CandidateNurtureSequence,
      title: 'Candidate Nurture Emails',
      icon: Website,
      previewUrl: '',
    },
  },
}

export const flowOSchemas: ChannelTypeSchemas = {
  [ChannelType.SMSMessages]: {
    ...FlowOSchema({ generationType: ChannelType.SMSMessages }),
    meta: {
      type: ChannelType.SMSMessages,
      channel: ChannelType.SMSMessages,
      title: 'WhatsApp Message',
      icon: WhatsApp,
      previewUrl: '',
    },
  },
}

export const flowP1Schemas: ChannelTypeSchemas = {
  [ChannelType.LandingPage]: {
    ...FlowP1Schema({ generationType: ChannelType.LandingPage }),
    meta: {
      type: ChannelType.LandingPage,
      channel: ChannelType.LandingPage,
      title: 'Landing Page',
      icon: Website,
      previewUrl: '',
    },
  },
}

export const flowP2Schemas: ChannelTypeSchemas = {
  [ChannelType.AboutUs]: {
    ...FlowP2Schema({ generationType: ChannelType.AboutUs }),
    meta: {
      type: ChannelType.AboutUs,
      channel: ChannelType.AboutUs,
      title: 'About Us Page',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.Pricing]: {
    ...FlowP2Schema({ generationType: ChannelType.Pricing }),
    meta: {
      type: ChannelType.Pricing,
      channel: ChannelType.Pricing,
      title: 'Pricing Page',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.Mission]: {
    ...FlowP2Schema({ generationType: ChannelType.Mission }),
    meta: {
      type: ChannelType.Mission,
      channel: ChannelType.Mission,
      title: 'Mission Page',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.Impact]: {
    ...FlowP2Schema({ generationType: ChannelType.Impact }),
    meta: {
      type: ChannelType.Impact,
      channel: ChannelType.Impact,
      title: 'Impact Page',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.HelpDocs]: {
    ...FlowP2Schema({ generationType: ChannelType.HelpDocs }),
    meta: {
      type: ChannelType.HelpDocs,
      channel: ChannelType.HelpDocs,
      title: 'Customer Help Docs',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.CareInstructions]: {
    ...FlowP2Schema({ generationType: ChannelType.CareInstructions }),
    meta: {
      type: ChannelType.CareInstructions,
      channel: ChannelType.CareInstructions,
      title: 'Product Care Instructions',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.BillingAndPayments]: {
    ...FlowP2Schema({ generationType: ChannelType.BillingAndPayments }),
    meta: {
      type: ChannelType.BillingAndPayments,
      channel: ChannelType.BillingAndPayments,
      title: 'Billing & Payments FAQs',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.JobDescription]: {
    ...FlowP2Schema({ generationType: ChannelType.JobDescription }),
    meta: {
      type: ChannelType.JobDescription,
      channel: ChannelType.JobDescription,
      title: 'Job Description Copy',
      icon: Website,
      previewUrl: '',
    },
  },
}

export const flowP3Schemas: ChannelTypeSchemas = {
  [ChannelType.FAQs]: {
    ...FlowP3Schema({ generationType: ChannelType.FAQs }),
    meta: {
      type: ChannelType.FAQs,
      channel: ChannelType.FAQs,
      title: 'FAQ Page',
      icon: Website,
      previewUrl: '',
    },
  },
}

export const flowRSchemas: ChannelTypeSchemas = {
  [ChannelType.OnePager]: {
    ...FlowRSchema({ generationType: ChannelType.OnePager }),
    meta: {
      type: ChannelType.OnePager,
      channel: ChannelType.OnePager,
      title: 'Sales One Pager',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.ProductDemo]: {
    ...FlowRSchema({ generationType: ChannelType.ProductDemo }),
    meta: {
      type: ChannelType.ProductDemo,
      channel: ChannelType.ProductDemo,
      title: 'Product Demo Script',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.PreCallChecklist]: {
    ...FlowRSchema({ generationType: ChannelType.PreCallChecklist }),
    meta: {
      type: ChannelType.PreCallChecklist,
      channel: ChannelType.PreCallChecklist,
      title: 'Pre-call Checklist',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.CallScript]: {
    ...FlowRSchema({ generationType: ChannelType.CallScript }),
    meta: {
      type: ChannelType.CallScript,
      channel: ChannelType.CallScript,
      title: 'Sales Call Script',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.Research]: {
    ...FlowRSchema({ generationType: ChannelType.Research }),
    meta: {
      type: ChannelType.Research,
      channel: ChannelType.Research,
      title: 'Customer Research Brief',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.BattleCard]: {
    ...FlowRSchema({ generationType: ChannelType.BattleCard }),
    meta: {
      type: ChannelType.BattleCard,
      channel: ChannelType.BattleCard,
      title: 'Sales Battle Card',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.Testimonial]: {
    ...FlowRSchema({ generationType: ChannelType.Testimonial }),
    meta: {
      type: ChannelType.Testimonial,
      channel: ChannelType.Testimonial,
      title: 'Sales Testimonial',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.ReplyTemplates]: {
    ...FlowRSchema({ generationType: ChannelType.ReplyTemplates }),
    meta: {
      type: ChannelType.ReplyTemplates,
      channel: ChannelType.ReplyTemplates,
      title: 'Customer Reply Templates',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.ReturnPolicy]: {
    ...FlowRSchema({ generationType: ChannelType.ReturnPolicy }),
    meta: {
      type: ChannelType.ReturnPolicy,
      channel: ChannelType.ReturnPolicy,
      title: 'Return Policy',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.ShippingPolicy]: {
    ...FlowRSchema({ generationType: ChannelType.ShippingPolicy }),
    meta: {
      type: ChannelType.ShippingPolicy,
      channel: ChannelType.ShippingPolicy,
      title: 'Shipping Policy',
      icon: Website,
      previewUrl: '',
    },
  },
  [ChannelType.PaymentConfirmation]: {
    ...FlowRSchema({ generationType: ChannelType.PaymentConfirmation }),
    meta: {
      type: ChannelType.PaymentConfirmation,
      channel: ChannelType.PaymentConfirmation,
      title: 'Payment Confirmation Copy',
      icon: Website,
      previewUrl: '',
    },
  },
}

export const flowZ1Schemas: ChannelTypeSchemas = {
  [ChannelType.InstagramCaptions]: {
    ...FlowZ1Schema({ generationType: ChannelType.InstagramCaptions }),
    meta: {
      type: ChannelType.InstagramCaptions,
      channel: ChannelType.InstagramCaptions,
      title: 'Instagram Captions',
      icon: Instagram,
      previewUrl: '',
    },
  },
}

export const flowZ2Schemas: ChannelTypeSchemas = {
  [ChannelType.InstagramReel]: {
    ...FlowZ2Schema({ generationType: ChannelType.InstagramReel }),
    meta: {
      type: ChannelType.InstagramReel,
      channel: ChannelType.InstagramReel,
      title: 'Instagram Reel Script',
      icon: Instagram,
      previewUrl: '',
    },
  },
  [ChannelType.TikTokScript]: {
    ...FlowZ2Schema({ generationType: ChannelType.TikTokScript }),
    meta: {
      type: ChannelType.TikTokScript,
      channel: ChannelType.TikTokScript,
      title: 'TikTok Script',
      icon: TikTok,
      previewUrl: '',
    },
  },
  [ChannelType.YoutubeScript]: {
    ...FlowZ2Schema({ generationType: ChannelType.YoutubeScript }),
    meta: {
      type: ChannelType.YoutubeScript,
      channel: ChannelType.YoutubeScript,
      title: 'YouTube Script',
      icon: YouTube,
      previewUrl: '',
    },
  },
  [ChannelType.FacebookPost]: {
    ...FlowZ2Schema({ generationType: ChannelType.FacebookPost }),
    meta: {
      type: ChannelType.FacebookPost,
      channel: ChannelType.FacebookPost,
      title: 'Facebook Reel Script',
      icon: Facebook,
      previewUrl: '',
    },
  },
}

export const flowH1Schemas = {
  [GenerationType.Campaign]: {
    ...FlowH1Schema({ generationType: GenerationType.Campaign }),
    meta: {
      type: GenerationType.Campaign,
      channel: GenerationType.Campaign,
      title: 'Multi-Channel Campaign',
      icon: PressRelease,
      previewUrl: '',
    },
  },
}

export const schematizedTextSchemas: GenerationTypeSchemas = {
  ...flowJSchemas,
  ...flowLSchemas,
  ...flowM1Schemas,
  ...flowM2Schemas,
  ...flowM3Schemas,
  ...flowNSchemas,
  ...flowOSchemas,
  ...flowP1Schemas,
  ...flowP2Schemas,
  ...flowP3Schemas,
  ...flowRSchemas,
}

export const mobileSchemas: WizardSchemas = {
  ...flowA1Schemas,
  ...flowA2Schemas,
  ...flowBSchemas,
  ...flowCSchemas,
  ...flowDSchemas,
  ...flowESchemas,
  ...flowFSchemas,
  ...flowGSchemas,
  ...flowISchemas,
  ...flowK1Schemas,
  ...flowZ1Schemas,
  ...flowZ2Schemas,
  ...flowH1Schemas,
  ...schematizedTextSchemas,
}
